import Identificacion from "../Comun/Identificacion"

export default class ParametroIncluirAutorizacion {

    constructor() {
        this.NumeroAutorizacion = "";
        this.Identificacion = new Identificacion();
        this.RepresentanteLegal = new Identificacion();
        this.Documentos = [];
        this.TipoAutorizacion =0;
        this.EntidadTramite = "";
        this.UsuarioTramite = "";
    }


    NumeroAutorizacion: string;
    Identificacion: Identificacion;
    RepresentanteLegal: Identificacion;
    Documentos: any;
    TipoAutorizacion: number;
    EntidadTramite: string;
    UsuarioTramite: string;
}